import gsap from "gsap";
import { Sizes } from "../_app/cuchillo/core/Sizes";
import { Maths } from "../_app/cuchillo/utils/Maths";
import Flappy from "./Flappy";

export default class Tube {
  static isEnabled = false;
  static total = 0;
  static tubes = [];
  static sprites = [];

  static templates = [
    {
      src:IMAGE_BOT_1,
      width:260,
      height:596,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_BOT_2,
      width:376,
      height:600,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_LATA,
      width:336,
      height:376,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_PATATAS,
      width:440,
      height:532,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_PAVO,
      width:512,
      height:304,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_VELAS,
      width:404,
      height:428,
      offset:23 * Sizes.RATIO,
      position:"bottom" 
    },
    {
      src:IMAGE_TOP_1,
      width:552,
      height:356,
      offset:23 * Sizes.RATIO,
      position:"top" 
    },
    {
      src:IMAGE_TOP_2,
      width:416,
      height:284,
      offset:23 * Sizes.RATIO,
      position:"top" 
    },
    {
      src:IMAGE_TOP_1,
      width:552,
      height:356,
      offset:23 * Sizes.RATIO,
      position:"top" 
    },
    {
      src:IMAGE_TOP_2,
      width:416,
      height:284,
      offset:23 * Sizes.RATIO,
      position:"top" 
    },
  ];


  static tick = 0;
  static limitTick = 0;
  static positions = [];
  static contRepeat = 0;
  static totalSprites = 0;
  static anterior = 0;
  static cont = 0;
  static current = 0;
  static isFirst = true;
  static getRandomSprite() {
    this.current = this.current + 1 >= this.totalSprites? 0 : this.current + 1;
    return Tube.sprites[this.current];
  }

  static getType() {
    let current = Math.random() > 0.5 ? 1 : -1;
    if(current === this.anterior) {
      this.contRepeat++;
      if(this.contRepeat > 2) {
        current = current * -1;
        this.contRepeat = 0;
      }
    } else {
      this.contRepeat = 0;
    }

    this.anterior = current;
  
    return current;
  }

  static preloadImages(__call) {
    
    const promises = this.templates.map((sprite) => {
      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
          resolve();
        };

       

        image.src = `${sprite.src}`;
      });
    });

    Promise.all(promises).then(() => {
      __call();
    });
  }

  static init() {
    this.limitTick = Flappy.width * Flappy.defaults.respawn;
    this.isEnabled = true;
    this.tick = 0;
    this.setupSprites();
    this.addTube();
  }

  static setupSprites() {
    const minScale = 10;
    const maxScale = 14;
    const requiredItems = 400;
  
    // Vaciar los sprites existentes
    this.current = 0;
    this.sprites = [];
  
    while (this.sprites.length < requiredItems) {
      // Iterar sobre los templates y clonar hasta alcanzar el mínimo requerido
      for (let i = 0; i < this.templates.length && this.sprites.length < requiredItems; i++) {
        const template = this.templates[i];
        
        // Generar un factor de escala aleatorio
        const scale = Maths.maxminRandom(maxScale, minScale)/10;
        
        const w = (template.width/2) * Sizes.RATIO;
        const h = (template.height/2) * Sizes.RATIO;
        

        // Clonar y modificar el template
        const newSprite = {
          src: template.src,
          width: Math.round(w * scale),
          height: Math.round(h * scale),
          position: template.position,
          offset: template.offset * scale, // Escalar también el offset
          init: Flappy.width,
          end: -Math.round(w * scale),
          y: template.position === "bottom" 
            ? Flappy.height - Math.round(h * scale) 
            : 0,
        };
  
        this.sprites.push(newSprite);
      }
    }
  
    this.totalSprites = this.sprites.length;

    // Desordenar los sprites según las condiciones
    this.shuffleSprites();
  }
  
  static shuffleSprites() {
    const shuffled = [];
    let bottomCount = 0;
    let topCount = 0;
  
    // Copiar los sprites generados
    const spritesCopy = [...this.sprites];
  
    while (spritesCopy.length > 0) {
      // Filtrar candidatos según las condiciones
      const candidates = spritesCopy.filter((sprite, index) => {
        const previous = shuffled[shuffled.length - 1];
        const previous2 = shuffled[shuffled.length - 2];
  
        const isSameAsPrevious = previous && sprite.src === previous.src;
        const wouldExceedBottom = sprite.position === "bottom" && bottomCount >= 3;
        const wouldExceedTop = sprite.position === "top" && topCount >= 2;
        const wouldBreakStreak = 
          sprite.position === "bottom" && previous?.position === "bottom" && previous2?.position === "bottom" ||
          sprite.position === "top" && previous?.position === "top";
  
        return !isSameAsPrevious && !wouldExceedBottom && !wouldExceedTop && !wouldBreakStreak;
      });
  
      if (candidates.length === 0) {
        console.error("No valid candidates to satisfy conditions");
        break;
      }
  
      // Elegir un sprite aleatorio de los candidatos
      const randomIndex = Math.floor(Math.random() * candidates.length);
      const chosen = candidates[randomIndex];
  
      // Agregar el sprite a la lista final y eliminarlo del array de origen
      shuffled.push(chosen);
      spritesCopy.splice(spritesCopy.indexOf(chosen), 1);
  
      // Actualizar los contadores
      if (chosen.position === "bottom") {
        bottomCount++;
        topCount = 0;
      } else if (chosen.position === "top") {
        topCount++;
        bottomCount = 0;
      } else {
        bottomCount = 0;
        topCount = 0;
      }
    }
  
    this.sprites = shuffled;
  }

  static hide() {
    this.isEnabled = false;
    this.isFirst = true;
  }

  static addTube() {
    this.total = this.tubes.push(new Tube());
    this.isFirst = false;
  }

  static reset() {
    this.tick = 0;
    this.limitTick = 0;
    this.isEnabled = false;
    this.dispose();
  }

  static update(__ctx, __speed) {
    let deadTube = null;
    for (let i = 0; i < this.total; i++) {
      this.tubes[i].update(__speed);
      this.tubes[i].draw(__ctx);
      deadTube = this.tubes[i].isDead ? i : deadTube;
    }

    if(!this.isEnabled) return;

    if(deadTube !== null) {
      this.tubes.splice(deadTube, 1);
      this.total--;
    }

    this.tick = this.tick + __speed;
    if(this.tick >= this.limitTick) {
      this.tick = 0;
      this.addTube();
    }
  }

  static dispose() {
    // Eliminar referencias a las imágenes
    
    // Restablecer propiedades estáticas a sus valores iniciales
    this.isEnabled = false;
    this.total = 0;
    this.tubes = [];
    this.tick = 0;
    this.limitTick = 0;
    this.positions = [];
    this.contRepeat = 0;
    this.anterior = 0;
    this.cont = 0;
  }

  position = {
    x: 0,
    y: 0,
  }
  data;
  size;
  hitArea = {}
  type = 1;
  isDead = false;
  passed = false;
  isVisibleUI = true;

  constructor(__y) {
    this.size = Tube.getRandomSprite();
    this.image = new Image();
    this.image.src = `${this.size.src}`;    
    this.position.x = this.size.init * 1.5;
    this.position.y = this.size.y;

    console.log(this.size)

    this.hitArea = {
      width: this.size.width - this.size.offset * 2,
      height: this.size.height - this.size.offset * 2,
      y: this.size.position == "bottom"? this.size.y + this.size.offset :  this.size.y,
      x: this.position.x + this.size.offset
    }

    this.image.onload = () => {
      this.isEnabled = true;
    }
  }

  update(__speed, __y) {
    if(this.position.x < this.size.end) {
      this.isDead = false;
    }
    this.position.x = this.position.x - __speed;
    this.hitArea.x = this.position.x + this.size.offset;
  }

  draw(ctx) {
    if (!this.isEnabled) return;
    //Dibuja un rectangulo

    //Dibuja la imagen
    
    
  
    // Dibuja los rectángulos azules con opacidad vibrante
    //
    ctx.drawImage(this.image, this.position.x, this.position.y, this.size.width, this.size.height);

    const resto = this.isVisibleUI? 20 : 10;
    this.isVisibleUI = Flappy.tick % resto == 0? !this.isVisibleUI : this.isVisibleUI;
    const opacity = this.isVisibleUI? 1 : 0;

    ctx.fillStyle = `rgba(255, 255, 0, ${opacity})`;

    const wb = 50 * Sizes.RATIO;
    const wh = 5 * Sizes.RATIO;
    const whb = wb - wh;

    if(this.size.position == "bottom") {
      ctx.fillRect(this.position.x, this.position.y, wb, wh);
      ctx.fillRect(this.position.x, this.position.y, wh, wb);
      ctx.fillRect(this.position.x + this.size.width - wb, this.position.y, wb, wh);
      ctx.fillRect(this.position.x + this.size.width - wh, this.position.y, wh, wb); 
    } else {
      ctx.fillRect(this.position.x, this.position.y + this.size.height, wb, wh);
      ctx.fillRect(this.position.x, this.position.y + this.size.height - whb, wh, wb);
      ctx.fillRect(this.position.x + this.size.width - wb, this.position.y + this.size.height, wb, wh);
      ctx.fillRect(this.position.x + this.size.width - wh, this.position.y + this.size.height - whb, wh, wb); 
    }
       
  }
}
